import React, { useMemo } from 'react'
import { View } from 'react-native'

export function Spacer({
  height = 16,
  width = 0,
}: {
  height?: number | undefined
  width?: number | undefined
}) {
  const style = useMemo(() => ({ height, width }), [height, width])
  return <View style={style} />
}
